import React from "react";
import { SelectForm, TextForm, DateForm, CurrencyForm, InputForm } from "./InputFields";
const SwitchFields = (
  e,
  custom = { mediaquery: true, handleChange: null, value: null }
) => {
  switch (e.type) {
    case "select":
      return (
        <SelectForm
          key={e.id}
          field={e}
          handleChange={custom.handleChange}
          value={custom.value}
          mediaquery={custom.mediaquery}
        />
      );
    // case "text":
    //   return (
    //     <TextForm
    //       key={e.id}
    //       field={e}
    //       regex={e.regex_filter ? e.regex_filter : false}
    //       handleChange={custom.handleChange}
    //       value={custom.value}
    //       mediaquery={custom.mediaquery}
    //     />
    //   );
    case "date":
      return (
        <DateForm
          key={e.id}
          field={e}
          handleChange={custom.handleChange}
          value={custom.value}
          mediaquery={custom.mediaquery}
        />
      );
    case "currency":
      return (
        <CurrencyForm
          key={e.id}
          field={e}
          handleChange={custom.handleChange}
          value={custom.value}
          mediaquery={custom.mediaquery}
        />
      );
    default:
      return (
        <InputForm
          key={e.id}
          field={e}
          regex={e.regex_filter ? e.regex_filter : false}
          handleChange={custom.handleChange}
          value={custom.value}
          mediaquery={custom.mediaquery}
        />
      );
  }
};

export default SwitchFields;
